<template>
  <div v-if="!isMobile()">
    <div
      class="section-dragologistic"
      id="dragologistic-section"
      data-background-color="white"
      style="margin-top: 120px"
    >
      <div style="width: 100%">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <div
              class="video-container4"
              style="width: 1280px; height: 720px; margin:0 auto 160px;"
            >
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://www.youtube.com/embed/qF-_i2ZnMa0"
              ></iframe>
            </div>
            <!-- <h3 data-aos="fade-up" class="title deco3">LEGENDARY DRAGO</h3> -->
            <div class="main-box-title-wrap" data-aos="fade-up">
              <div class="main-box-deco-wrap">
                <h2>LEGENDARY DRAGO</h2>
              </div>
            </div>
            <div class="drago-slide-wrap">
              <carousel 
                navigation-enabled="true"
                navigationNextLabel=""
                navigationPrevLabel=""
                perPage="1"
                style="margin-bottom: 50px"
                >
                <slide>
                  <div
                    style="
                      width: 1280px;
                      height: 700px;
                      margin-left: calc(50% - 640px);
                    "
                  >
                    <div
                      style="
                        width: 640px;
                        float: left;
                        height: 100%;
                        margin-top: 60px;
                      "
                    >
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 20px;
                          font-weight: bold;
                          line-height: 1.38;
                          letter-spacing: -0.2px;
                          text-align: left;
                          color: rgba(8, 15, 58, 0.3);
                          margin-top: 115px;
                        "
                      >
                        THE LEGENDARY
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 60.5px;
                          font-weight: bold;
                          letter-spacing: -1.51px;
                          text-align: left;
                          color: #000;
                        "
                      >
                        DARK DRAGO
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 16.5px;
                          font-weight: 600;
                          letter-spacing: -0.17px;
                          text-align: left;
                          color: #000;
                          margin-top: 80px;
                        "
                      >
                        Meet Ahriman, the legendary Dark Drago<br />
                        As engraved in the oracle bones of Gathas “when the
                        dark<br />
                        opens wide, its gloom lurks beneath the kingdom,<br />
                        foreboding dreadful plague and raid. Left nothing but<br />
                        blood and ruin behind”.<br />
                        The Drago’s name was forbidden to utter for ages.
                      </div>
                    </div>
                    <div style="width: 640px; float: right; height: 100%">
                      <img
                        src="/img/dark-drago-bg.png"
                        style="margin-top: 60px; margin-left: 0px"
                      />
                      <img
                        src="/img/dark-drago.png"
                        style="margin-top: -640px; margin-left: -323px"
                      />
                    </div>
                  </div>
                </slide>
                <slide>
                  <div
                    style="
                      width: 1280px;
                      height: 700px;
                      margin-left: calc(50% - 640px);
                    "
                  >
                    <div
                      style="
                        width: 640px;
                        float: left;
                        height: 100%;
                        margin-top: 60px;
                      "
                    >
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 20px;
                          font-weight: bold;
                          line-height: 1.38;
                          letter-spacing: -0.2px;
                          text-align: left;
                          color: rgba(8, 15, 58, 0.3);
                          margin-top: 115px;
                        "
                      >
                        THE LEGENDARY
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 60.5px;
                          font-weight: bold;
                          letter-spacing: -1.51px;
                          text-align: left;
                          color: #000;
                        "
                      >
                        LIGHT DRAGO
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 16.5px;
                          font-weight: 600;
                          letter-spacing: -0.17px;
                          text-align: left;
                          color: #000;
                          margin-top: 80px;
                        "
                      >
                        Meet Orko, the legendary Light Drago Ancient myth
                        depicts<br />
                        that Orko’s tail carries mighty thunderbolts to fight
                        the<br />
                        band of cyclops or even light the entire Universe. Its<br />
                        spiky-shaped feather electrocuted an entire armada in
                        the<br />
                        blink of an eye.
                      </div>
                    </div>
                    <div style="width: 640px; float: right; height: 100%">
                      <img
                        src="/img/light-drago-bg.png"
                        style="margin-top: 60px; margin-left: 0px"
                      />
                      <img
                        src="/img/light-drago.png"
                        style="margin-top: -640px; margin-left: -323px"
                      />
                    </div>
                  </div>
                </slide>
                <slide>
                  <div
                    style="
                      width: 1280px;
                      height: 700px;
                      margin-left: calc(50% - 640px);
                    "
                  >
                    <div
                      style="
                        width: 640px;
                        float: left;
                        height: 100%;
                        margin-top: 60px;
                      "
                    >
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 20px;
                          font-weight: bold;
                          line-height: 1.38;
                          letter-spacing: -0.2px;
                          text-align: left;
                          color: rgba(8, 15, 58, 0.3);
                          margin-top: 115px;
                        "
                      >
                        THE LEGENDARY
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 60.5px;
                          font-weight: bold;
                          letter-spacing: -1.51px;
                          text-align: left;
                          color: #000;
                        "
                      >
                        TERRA DRAGO
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 16.5px;
                          font-weight: 600;
                          letter-spacing: -0.17px;
                          text-align: left;
                          color: #000;
                          margin-top: 80px;
                        "
                      >
                        Meet Gaya, the legendary Terra Drago The earthy Drago
                        can<br />
                        suddenly turn a barren prairie into plowland or amazon.<br />
                        Gaya was blessing to the growers while anathema for<br />
                        caravans. Gigantic temples were built to worship the<br />
                        Tlāloc, incarnation of this mystic Drago.
                      </div>
                    </div>
                    <div style="width: 640px; float: right; height: 100%">
                      <img
                        src="/img/terra-drago-bg.png"
                        style="margin-top: 60px; margin-left: 0px"
                      />
                      <img
                        src="/img/terra-drago.png"
                        style="margin-top: -640px; margin-left: -323px"
                      />
                    </div>
                  </div>
                </slide>
                <slide>
                  <div
                    style="
                      width: 1280px;
                      height: 700px;
                      margin-left: calc(50% - 640px);
                    "
                  >
                    <div
                      style="
                        width: 640px;
                        float: left;
                        height: 100%;
                        margin-top: 60px;
                      "
                    >
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 20px;
                          font-weight: bold;
                          line-height: 1.38;
                          letter-spacing: -0.2px;
                          text-align: left;
                          color: rgba(8, 15, 58, 0.3);
                          margin-top: 115px;
                        "
                      >
                        THE LEGENDARY
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 60.5px;
                          font-weight: bold;
                          letter-spacing: -1.51px;
                          text-align: left;
                          color: #000;
                        "
                      >
                        FIRE DRAGO
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 16.5px;
                          font-weight: 600;
                          letter-spacing: -0.17px;
                          text-align: left;
                          color: #000;
                          margin-top: 80px;
                        "
                      >
                        Meet Ferona, the legendary Fire Drago This ferocious
                        Drago<br />
                        is known to be the cause of the infamous conflagration<br />
                        which burnt down the ancient tropical city-state of<br />
                        Themiscia. The blaze has changed the course of history
                        in<br />
                        the genesis continents.
                      </div>
                    </div>
                    <div style="width: 640px; float: right; height: 100%">
                      <img
                        src="/img/fire-drago-bg.png"
                        style="margin-top: 60px; margin-left: 0px"
                      />
                      <img
                        src="/img/fire-drago.png"
                        style="margin-top: -640px; margin-left: -323px"
                      />
                    </div>
                  </div>
                </slide>
                <slide>
                  <div
                    style="
                      width: 1280px;
                      height: 700px;
                      margin-left: calc(50% - 640px);
                    "
                  >
                    <div
                      style="
                        width: 640px;
                        float: left;
                        height: 100%;
                        margin-top: 60px;
                      "
                    >
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 20px;
                          font-weight: bold;
                          line-height: 1.38;
                          letter-spacing: -0.2px;
                          text-align: left;
                          color: rgba(8, 15, 58, 0.3);
                          margin-top: 115px;
                        "
                      >
                        THE LEGENDARY
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 60.5px;
                          font-weight: bold;
                          letter-spacing: -1.51px;
                          text-align: left;
                          color: #000;
                        "
                      >
                        AQUA DRAGO
                      </div>
                      <div
                        style="
                          font-family: Poppins;
                          font-size: 16.5px;
                          font-weight: 600;
                          letter-spacing: -0.17px;
                          text-align: left;
                          color: #000;
                          margin-top: 80px;
                        "
                      >
                        Meet Khione, the legendary Aqua Drago It is said that<br />
                        Khione does not forgive those who dare to intrude the<br />
                        glacier mountains of Khineca, the frozen kingdom of the<br />
                        legendary Drago. When Khione spread its wings upon its<br />
                        victims, the blizzard and avalanch follows, silencing
                        the<br />
                        world under the white blanket.
                      </div>
                    </div>
                    <div style="width: 640px; float: right; height: 100%">
                      <img
                        src="/img/aqua-drago-bg.png"
                        style="margin-top: 60px; margin-left: 0px"
                      />
                      <img
                        src="/img/aqua-drago.png"
                        style="margin-top: -640px; margin-left: -323px"
                      />
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
            <h1 data-aos="fade-up" class="title deco3">
              {{ $t(`play-to-earn logic`) }}
            </h1>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin: 90px 0 100px;
              "
            >
              <div
                style="
                  margin-top: 200px;
                  margin-left: -180px;
                "
              ><img src="/img/drago-deco-01.png" /></div>
              <div
                style="
                  margin-left: -70px;
                "
              ><img src="/img/logistics.png" /></div>
              <div
                style="
                  margin-right: -140px;
                "
              ><img src="/img/drago-deco-02.png" /></div>
            </div>
            <div
              class="governance-effect dddddddd"
              style="
                width: 100%;
                height: 440px;
                margin: auto;
                margin-top: 50px;
                background-position: center;
                background-image: url('/img/img_drago.png');
                background-size: cover;
                background-repeat: no-repeat;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
                  height: 100%;
                "
              >
                <div class="dragoText">
                  <h2>Drago & dst</h2>         
                </div>
                <div
                  style="
                    display: flex;
                  "
                >
                  <div
                    style="
                      width: 240px;
                      height: 60px;
                      line-height: 58px;
                      margin:0 20px 0 0;
                      border-radius: 4px;
                      background-color: #0072ff;
                      color: #fff;
                      font-size: 16px;
                      font-weight: 600;
                      cursor: pointer;
                    "
                    @click="goLearnDrago()"
                  >
                    Learn More
                  </div>
                  <div
                    @click="toggleShow"
                    class="toggleWrap"
                    :class="show ? 'on' : 'off'"
                    style="
                      margin:0 20px 0 0;
                    "
                  >
                    BUY DRAGO
                    <ul
                      style="
                        background-color: #004ec2;
                        font-size:13px;
                      "
                      v-if="show"
                      class="toggleMenu"
                    >
                      <li @click="goBuyDrago()">OPENSEA(Ethereum)</li>
                      <li @click="goBuyDrago2()">OPENSEA(Polygon)</li>
                      <li @click="goBuyDrago3()">TOFU(Ethereum)</li>
                      <li @click="goBuyDrago4()">TOFU(Polygon)</li>
                      <li @click="goBuyDrago5()">DEW(Polygon)</li>
                    </ul>
                  </div>
                  <div
                    @click="toggleShowShow"
                    class="toggleWrap"
                    :class="showshow ? 'on' : 'off'"
                  >
                    Rental
                    <ul
                      style="
                        background-color: #004ec2;
                        font-size:13px;
                      "
                      v-if="showshow"
                      class="toggleMenu"
                    >
                      <li @click="goRental()">Rental at Official Discord</li>
                      <li @click="goRental2()">Rental at lootrush</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-m section-dragologistic"
      id="dragologistic-section"
      style="padding-bottom: 0px !important"
      data-background-color="white"
    >
      <div class="container" style="width: 100%; min-height: 400px">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <div class="video-container5" style="width: 100%; margin-left: 0%">
              <iframe
                width="100%"
                height="100%"
                id="ytplayer"
                allowfullscreen
                frameborder="0"
                src="https://www.youtube.com/embed/qF-_i2ZnMa0"
              ></iframe>
            </div>
            <h1 class="title-m deco1" style="margin-top: 40px">
              LEGENDARY DRAGO
            </h1>
            <carousel perPage="1" style="margin-bottom: 50px">
              <slide>
                <div style="width: 90%; height: 600px; margin-left: 5%">
                  <div style="width: 100%; height: 200px; margin-top: 0px">
                    <div style="width: 100%; margin-top: 0px">
                      <img src="/img/dark-drago.png" style="margin-top: 40px" />
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 12px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 20px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 30px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 10px;
                      "
                    >
                      DARK DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 10px;
                        font-weight: 600;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 20px;
                      "
                    >
                      Meet Ahriman, the legendary Dark Drago<br />
                      As engraved in the oracle bones of Gathas “when the
                      dark<br />
                      opens wide, its gloom lurks beneath the kingdom,<br />
                      foreboding dreadful plague and raid. Left nothing but<br />
                      blood and ruin behind”.<br />
                      The Drago’s name was forbidden to utter for ages.
                    </div>
                  </div>
                </div>
              </slide>
              <slide>
                <div style="width: 90%; height: 600px; margin-left: 5%">
                  <div style="width: 100%; height: 200px; margin-top: 0px">
                    <div style="width: 100%; margin-top: 0px">
                      <img
                        src="/img/light-drago.png"
                        style="margin-top: 40px"
                      />
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 12px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 20px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 30px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 10px;
                      "
                    >
                      LIGHT DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 10px;
                        font-weight: 600;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 20px;
                      "
                    >
                      Meet Orko, the legendary Light Drago Ancient myth
                      depicts<br />
                      that Orko’s tail carries mighty thunderbolts to fight
                      the<br />
                      band of cyclops or even light the entire Universe. Its<br />
                      spiky-shaped feather electrocuted an entire armada in
                      the<br />
                      blink of an eye.
                    </div>
                  </div>
                </div>
              </slide>
              <slide>
                <div style="width: 90%; height: 600px; margin-left: 5%">
                  <div style="width: 100%; height: 200px; margin-top: 0px">
                    <div style="width: 100%; margin-top: 0px">
                      <img
                        src="/img/terra-drago.png"
                        style="margin-top: 40px"
                      />
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 12px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 20px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 30px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 10px;
                      "
                    >
                      TERRA DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 10px;
                        font-weight: 600;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 20px;
                      "
                    >
                      Meet Gaya, the legendary Terra Drago The earthy Drago
                      can<br />
                      suddenly turn a barren prairie into plowland or amazon.<br />
                      Gaya was blessing to the growers while anathema for<br />
                      caravans. Gigantic temples were built to worship the<br />
                      Tlāloc, incarnation of this mystic Drago.
                    </div>
                  </div>
                </div>
              </slide>
              <slide>
                <div style="width: 90%; height: 600px; margin-left: 5%">
                  <div style="width: 100%; height: 200px; margin-top: 0px">
                    <div style="width: 100%; margin-top: 0px">
                      <img src="/img/fire-drago.png" style="margin-top: 40px" />
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 12px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 20px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 30px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 10px;
                      "
                    >
                      FIRE DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 10px;
                        font-weight: 600;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 20px;
                      "
                    >
                      Meet Ferona, the legendary Fire Drago This ferocious
                      Drago<br />
                      is known to be the cause of the infamous conflagration<br />
                      which burnt down the ancient tropical city-state of<br />
                      Themiscia. The blaze has changed the course of history
                      in<br />
                      the genesis continents.
                    </div>
                  </div>
                </div>
              </slide>
              <slide>
                <div style="width: 90%; height: 600px; margin-left: 5%">
                  <div style="width: 100%; height: 200px; margin-top: 0px">
                    <div style="width: 100%; margin-top: 0px">
                      <img src="/img/aqua-drago.png" style="margin-top: 40px" />
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 12px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 20px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 30px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 10px;
                      "
                    >
                      AQUA DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 10px;
                        font-weight: 600;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 20px;
                      "
                    >
                      Meet Khione, the legendary Aqua Drago It is said that<br />
                      Khione does not forgive those who dare to intrude the<br />
                      glacier mountains of Khineca, the frozen kingdom of the<br />
                      legendary Drago. When Khione spread its wings upon its<br />
                      victims, the blizzard and avalanch follows, silencing
                      the<br />
                      world under the white blanket.
                    </div>
                  </div>
                </div>
              </slide>
              <!-- <slide>
                <div
                  style="
                    width: 1280px;
                    height: 700px;
                    margin-left: calc(50% - 640px);
                  "
                >
                  <div
                    style="
                      width: 640px;
                      float: left;
                      height: 100%;
                      margin-top: 60px;
                    "
                  >
                    <div
                      style="
                        opacity: 0.3;
                        font-family: Poppins;
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 115px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 60.5px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 30px;
                      "
                    >
                      LIGHT DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 16.5px;
                        font-weight: 600;
                        line-height: 1.67;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 80px;
                      "
                    >
                      Meet Orko, the legendary Light Drago Ancient myth
                      depicts<br />
                      that Orko’s tail carries mighty thunderbolts to fight
                      the<br />
                      band of cyclops or even light the entire Universe. Its<br />
                      spiky-shaped feather electrocuted an entire armada in
                      the<br />
                      blink of an eye.
                    </div>
                  </div>
                  <div style="width: 640px; float: right; height: 100%">
                    <img
                      src="/img/light-drago-bg.png"
                      style="margin-top: 60px; margin-left: 0px"
                    />
                    <img
                      src="/img/light-drago.png"
                      style="margin-top: -640px; margin-left: -323px"
                    />
                  </div>
                </div>
              </slide>
              <slide>
                <div
                  style="
                    width: 1280px;
                    height: 700px;
                    margin-left: calc(50% - 640px);
                  "
                >
                  <div
                    style="
                      width: 640px;
                      float: left;
                      height: 100%;
                      margin-top: 60px;
                    "
                  >
                    <div
                      style="
                        opacity: 0.3;
                        font-family: Poppins;
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 115px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 60.5px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 30px;
                      "
                    >
                      TERRA DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 16.5px;
                        font-weight: 600;
                        line-height: 1.67;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 80px;
                      "
                    >
                      Meet Gaya, the legendary Terra Drago The earthy Drago
                      can<br />
                      suddenly turn a barren prairie into plowland or amazon.<br />
                      Gaya was blessing to the growers while anathema for<br />
                      caravans. Gigantic temples were built to worship the<br />
                      Tlāloc, incarnation of this mystic Drago.
                    </div>
                  </div>
                  <div style="width: 640px; float: right; height: 100%">
                    <img
                      src="/img/terra-drago-bg.png"
                      style="margin-top: 60px; margin-left: 0px"
                    />
                    <img
                      src="/img/terra-drago.png"
                      style="margin-top: -640px; margin-left: -323px"
                    />
                  </div>
                </div>
              </slide>
              <slide>
                <div
                  style="
                    width: 1280px;
                    height: 700px;
                    margin-left: calc(50% - 640px);
                  "
                >
                  <div
                    style="
                      width: 640px;
                      float: left;
                      height: 100%;
                      margin-top: 60px;
                    "
                  >
                    <div
                      style="
                        opacity: 0.3;
                        font-family: Poppins;
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 115px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 60.5px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 30px;
                      "
                    >
                      FIRE DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 16.5px;
                        font-weight: 600;
                        line-height: 1.67;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 80px;
                      "
                    >
                      Meet Ferona, the legendary Fire Drago This ferocious
                      Drago<br />
                      is known to be the cause of the infamous conflagration<br />
                      which burnt down the ancient tropical city-state of<br />
                      Themiscia. The blaze has changed the course of history
                      in<br />
                      the genesis continents.
                    </div>
                  </div>
                  <div style="width: 640px; float: right; height: 100%">
                    <img
                      src="/img/fire-drago-bg.png"
                      style="margin-top: 60px; margin-left: 0px"
                    />
                    <img
                      src="/img/fire-drago.png"
                      style="margin-top: -640px; margin-left: -323px"
                    />
                  </div>
                </div>
              </slide>
              <slide>
                <div
                  style="
                    width: 1280px;
                    height: 700px;
                    margin-left: calc(50% - 640px);
                  "
                >
                  <div
                    style="
                      width: 640px;
                      float: left;
                      height: 100%;
                      margin-top: 60px;
                    "
                  >
                    <div
                      style="
                        opacity: 0.3;
                        font-family: Poppins;
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 1.38;
                        letter-spacing: -0.2px;
                        text-align: left;
                        color: rgba(8, 15, 58, 0.3);
                        margin-top: 115px;
                      "
                    >
                      THE LEGENDARY
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 60.5px;
                        font-weight: bold;
                        letter-spacing: -1.51px;
                        text-align: left;
                        color: #000;
                        margin-top: 30px;
                      "
                    >
                      AQUA DRAGO
                    </div>
                    <div
                      style="
                        font-family: Poppins;
                        font-size: 16.5px;
                        font-weight: 600;
                        line-height: 1.67;
                        letter-spacing: -0.17px;
                        text-align: left;
                        color: #000;
                        margin-top: 80px;
                      "
                    >
                      Meet Khione, the legendary Aqua Drago It is said that<br />
                      Khione does not forgive those who dare to intrude the<br />
                      glacier mountains of Khineca, the frozen kingdom of the<br />
                      legendary Drago. When Khione spread its wings upon its<br />
                      victims, the blizzard and avalanch follows, silencing the<br />
                      world under the white blanket.
                    </div>
                  </div>
                  <div style="width: 640px; float: right; height: 100%">
                    <img
                      src="/img/aqua-drago-bg.png"
                      style="margin-top: 60px; margin-left: 0px"
                    />
                    <img
                      src="/img/aqua-drago.png"
                      style="margin-top: -640px; margin-left: -323px"
                    />
                  </div>
                </div>
              </slide> -->
            </carousel>
            <h1 class="title-m deco1">{{ $t(`play-to-earn logic`) }}</h1>
            <div>
              <img
                src="/img/img_m_drago_sub.png"
                width="100%"
                style="margin-top: 10px"
              />
            </div>
          </div>
          <!-- <img
            src="/img/img_m_drago_sub_02.png"
            width="100%"
            style="margin-top: 10px"
          /> -->
          <div
            style="
              position: relative;
            "
          >
            <img
              src="/img/img_drago.png"
              width="100%"
            />
            <h4
              style="
                position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
                margin: 0;
                color: #fff; font-family: Poppins; font-size: 28px; font-weight: 900;
                letter-spacing: -2px;
                -webkit-text-stroke: 2px #000;
              "
            >DRAGO & DST</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      show: false,
      showshow: false,
    }
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goBuyDrago() {
      let url = "https://opensea.io/collection/lokdrago";
      window.open(url, "_blank");
    },
    goBuyDrago2() {
      let url = "https://opensea.io/collection/lokdrago-polygon";
      window.open(url, "_blank");
    },
    goBuyDrago3() {
      let url = "https://tofunft.com/collection/league-of-kingdoms-drago-ethereum/items";
      window.open(url, "_blank");
    },
    goBuyDrago4() {
      let url = "https://tofunft.com/collection/drago/items";
      window.open(url, "_blank");
    },
    goBuyDrago5() {
      let url = "https://dew.gg/collection/lokdrago-polygon";
      window.open(url, "_blank");
    },
    goRental() {
      let url = "https://discord.gg/lokofficial";
      window.open(url, "_blank");
    },
    goRental2() {
      let url = "https://www.lootrush.com/collections/lokdrago-polygon";
      window.open(url, "_blank");
    },
    goLearnDrago() {
      let url = "//whitepaper.playersarena.foundation/loka/lok-governance";
      window.open(url, "_blank");
    },
    goArena() {
      let url = "//play.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowShow() {
      this.showshow = !this.showshow;
    }
  },
};
</script>
<style>
  .dragoText h2 {
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 76px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: -2px;
    -webkit-text-stroke: 4px #000;
  }
  .toggleWrap {
    position: relative;
    width: 240px;
    height: 60px;
    line-height: 58px;
    border-radius: 4px;
    background-color: #0072ff;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }
  .toggleWrap::after {
    content: '';
    position:absolute;
    top:22px;
    right:40px;
    transform:rotate(135deg);
    width: 10px;
    height: 10px;
    border-radius: 2px;
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
  }
  .toggleWrap.on::after {
    top: 26px;
    transform:rotate(315deg);
  }
  ul {
    margin: 0; padding: 0 0 10px;
    border-radius: 0 0 4px 4px;
    overflow: hidden;
  }
  li {
    list-style: none;
  }
  .toggleMenu {
    /* margin-top: -1px; */
  }
  .toggleMenu li {
    line-height: 1.2;
    padding: 12px 0 12px 20px;
    background-image: url("/img/icon_link.png");
    background-repeat: no-repeat;
    background-position: 90% 50%;
    text-align: left;
  }
  .toggleMenu li:hover {
    background-color: #4196ff;
    overflow: hidden;
  }
  .drago-slide-wrap {
    width: 1280px; margin: 0 auto;
  }
  body .drago-slide-wrap .VueCarousel-navigation {
    position: absolute; bottom: 107px;
    z-index: 100;
  }
  body .drago-slide-wrap .VueCarousel-navigation-button:focus {
    outline: 0 !important;
  }
  body .drago-slide-wrap .VueCarousel-pagination {
    position: absolute; bottom: 100px; left: 80px;
  }
  body .drago-slide-wrap .VueCarousel-pagination .VueCarousel-dot-container {
    display: flex; align-items: center;
  }
  body .drago-slide-wrap .VueCarousel-pagination .VueCarousel-dot-container .VueCarousel-dot {
    width: 12px !important; height: 12px !important;
    margin: 0 10px !important; padding: 0 !important;
    border: none !important;
    background-color: rgba(0,0,0,0.1) !important;
    background-clip: border-box;
    box-sizing: border-box;
  }
  body .drago-slide-wrap .VueCarousel-pagination .VueCarousel-dot-container .VueCarousel-dot--active {
    width: 16px !important; height: 16px !important;
    background-color: #000 !important;
  }
  body .drago-slide-wrap .VueCarousel-navigation .VueCarousel-navigation-prev {
    width: 30px; height: 18px;
    left: 30px;
  }
  body .drago-slide-wrap .VueCarousel-navigation .VueCarousel-navigation-prev::after {
    content: '';
    position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    display: block;
    width: 30px; height: 18px;
    background-image: url('/img/renewal/icon-arr-left3.png');
  }
  body .drago-slide-wrap .VueCarousel-navigation .VueCarousel-navigation-next {
    width: 30px; height: 18px;
    right: -280px;
  }
  body .drago-slide-wrap .VueCarousel-navigation .VueCarousel-navigation-next::after {
    content: '';
    position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    display: block;
    width: 30px; height: 18px;
    background-image: url('/img/renewal/icon-arr-right3.png');
  }
</style>
